module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp12-0b3c8a6ba1edf7888a86a5205d4521d1.jpg";